/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PermissionsRouteImport } from './routes/permissions'
import { Route as SessionIdSessionRouteImport } from './routes/$sessionId/_session'
import { Route as DemoDemoUrlRouteImport } from './routes/demo.$demoUrl'
import { Route as SessionIdSessionIndexRouteImport } from './routes/$sessionId/_session/index'
import { Route as SessionIdSessionFinishedRouteImport } from './routes/$sessionId/_session/finished'
import { Route as SessionIdSessionPermissionsGuideRouteImport } from './routes/$sessionId/_session/permissionsGuide'
import { Route as SessionIdSessionUnsupportedDeviceRouteImport } from './routes/$sessionId/_session/unsupportedDevice'
import { Route as SessionIdSessionStepsAddNewWallRouteImport } from './routes/$sessionId/_session/_steps/addNewWall'
import { Route as SessionIdSessionStepsAddressRouteImport } from './routes/$sessionId/_session/_steps/address'
import { Route as SessionIdSessionIntroIndexRouteImport } from './routes/$sessionId/_session/intro/index'
import { Route as SessionIdSessionIntroPermissionsRouteImport } from './routes/$sessionId/_session/intro/permissions'
import { Route as SessionIdSessionIntroWallRouteImport } from './routes/$sessionId/_session/intro/wall'
import { Route as SessionIdSessionIntroWallDetailRouteImport } from './routes/$sessionId/_session/intro/wallDetail'
import { Route as SessionIdSessionIntroWelcomeRouteImport } from './routes/$sessionId/_session/intro/welcome'
import { Route as SessionIdSessionStepsExtraEquipmentIndexRouteImport } from './routes/$sessionId/_session/_steps/extraEquipment/index'
import { Route as SessionIdSessionStepsExtraEquipmentAmenityTypeRouteImport } from './routes/$sessionId/_session/_steps/extraEquipment/$amenityType'
import { Route as SessionIdSessionStepsOverviewIndexRouteImport } from './routes/$sessionId/_session/_steps/overview/index'
import { Route as SessionIdSessionStepsUtilityRoomIndexRouteImport } from './routes/$sessionId/_session/_steps/utilityRoom/index'
import { Route as SessionIdSessionStepsUtilityRoomAmenityTypeRouteImport } from './routes/$sessionId/_session/_steps/utilityRoom/$amenityType'
import { Route as SessionIdSessionStepsWallIndexRouteImport } from './routes/$sessionId/_session/_steps/wall/index'
import { Route as SessionIdSessionStepsWallWallNumberWallIdRouteImport } from './routes/$sessionId/_session/_steps/wall/$wallNumber.$wallId'
import { Route as SessionIdSessionStepsWallWallNumberWallIdWallDetailWallDetailIdRouteImport } from './routes/$sessionId/_session/_steps/wall/$wallNumber.$wallId_.wallDetail_.$wallDetailId'

const PermissionsRoute = PermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionIdSessionRoute = SessionIdSessionRouteImport.update({
  id: '/$sessionId/_session',
  path: '/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoDemoUrlRoute = DemoDemoUrlRouteImport.update({
  id: '/demo/$demoUrl',
  path: '/demo/$demoUrl',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionIdSessionIndexRoute = SessionIdSessionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SessionIdSessionRoute,
} as any)
const SessionIdSessionFinishedRoute =
  SessionIdSessionFinishedRouteImport.update({
    id: '/finished',
    path: '/finished',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionPermissionsGuideRoute =
  SessionIdSessionPermissionsGuideRouteImport.update({
    id: '/permissionsGuide',
    path: '/permissionsGuide',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionUnsupportedDeviceRoute =
  SessionIdSessionUnsupportedDeviceRouteImport.update({
    id: '/unsupportedDevice',
    path: '/unsupportedDevice',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionStepsAddNewWallRoute =
  SessionIdSessionStepsAddNewWallRouteImport.update({
    id: '/_steps/addNewWall',
    path: '/addNewWall',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionStepsAddressRoute =
  SessionIdSessionStepsAddressRouteImport.update({
    id: '/_steps/address',
    path: '/address',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionIntroIndexRoute =
  SessionIdSessionIntroIndexRouteImport.update({
    id: '/intro/',
    path: '/intro/',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionIntroPermissionsRoute =
  SessionIdSessionIntroPermissionsRouteImport.update({
    id: '/intro/permissions',
    path: '/intro/permissions',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionIntroWallRoute =
  SessionIdSessionIntroWallRouteImport.update({
    id: '/intro/wall',
    path: '/intro/wall',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionIntroWallDetailRoute =
  SessionIdSessionIntroWallDetailRouteImport.update({
    id: '/intro/wallDetail',
    path: '/intro/wallDetail',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionIntroWelcomeRoute =
  SessionIdSessionIntroWelcomeRouteImport.update({
    id: '/intro/welcome',
    path: '/intro/welcome',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionStepsExtraEquipmentIndexRoute =
  SessionIdSessionStepsExtraEquipmentIndexRouteImport.update({
    id: '/_steps/extraEquipment/',
    path: '/extraEquipment/',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionStepsExtraEquipmentAmenityTypeRoute =
  SessionIdSessionStepsExtraEquipmentAmenityTypeRouteImport.update({
    id: '/_steps/extraEquipment/$amenityType',
    path: '/extraEquipment/$amenityType',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionStepsOverviewIndexRoute =
  SessionIdSessionStepsOverviewIndexRouteImport.update({
    id: '/_steps/overview/',
    path: '/overview/',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionStepsUtilityRoomIndexRoute =
  SessionIdSessionStepsUtilityRoomIndexRouteImport.update({
    id: '/_steps/utilityRoom/',
    path: '/utilityRoom/',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionStepsUtilityRoomAmenityTypeRoute =
  SessionIdSessionStepsUtilityRoomAmenityTypeRouteImport.update({
    id: '/_steps/utilityRoom/$amenityType',
    path: '/utilityRoom/$amenityType',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionStepsWallIndexRoute =
  SessionIdSessionStepsWallIndexRouteImport.update({
    id: '/_steps/wall/',
    path: '/wall/',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionStepsWallWallNumberWallIdRoute =
  SessionIdSessionStepsWallWallNumberWallIdRouteImport.update({
    id: '/_steps/wall/$wallNumber/$wallId',
    path: '/wall/$wallNumber/$wallId',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionStepsWallWallNumberWallIdWallDetailWallDetailIdRoute =
  SessionIdSessionStepsWallWallNumberWallIdWallDetailWallDetailIdRouteImport.update(
    {
      id: '/_steps/wall/$wallNumber/$wallId_/wallDetail_/$wallDetailId',
      path: '/wall/$wallNumber/$wallId/wallDetail/$wallDetailId',
      getParentRoute: () => SessionIdSessionRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/permissions': typeof PermissionsRoute
  '/$sessionId': typeof SessionIdSessionRouteWithChildren
  '/demo/$demoUrl': typeof DemoDemoUrlRoute
  '/$sessionId/finished': typeof SessionIdSessionFinishedRoute
  '/$sessionId/permissionsGuide': typeof SessionIdSessionPermissionsGuideRoute
  '/$sessionId/unsupportedDevice': typeof SessionIdSessionUnsupportedDeviceRoute
  '/$sessionId/': typeof SessionIdSessionIndexRoute
  '/$sessionId/addNewWall': typeof SessionIdSessionStepsAddNewWallRoute
  '/$sessionId/address': typeof SessionIdSessionStepsAddressRoute
  '/$sessionId/intro/permissions': typeof SessionIdSessionIntroPermissionsRoute
  '/$sessionId/intro/wall': typeof SessionIdSessionIntroWallRoute
  '/$sessionId/intro/wallDetail': typeof SessionIdSessionIntroWallDetailRoute
  '/$sessionId/intro/welcome': typeof SessionIdSessionIntroWelcomeRoute
  '/$sessionId/intro/': typeof SessionIdSessionIntroIndexRoute
  '/$sessionId/extraEquipment/$amenityType': typeof SessionIdSessionStepsExtraEquipmentAmenityTypeRoute
  '/$sessionId/utilityRoom/$amenityType': typeof SessionIdSessionStepsUtilityRoomAmenityTypeRoute
  '/$sessionId/extraEquipment/': typeof SessionIdSessionStepsExtraEquipmentIndexRoute
  '/$sessionId/overview/': typeof SessionIdSessionStepsOverviewIndexRoute
  '/$sessionId/utilityRoom/': typeof SessionIdSessionStepsUtilityRoomIndexRoute
  '/$sessionId/wall/': typeof SessionIdSessionStepsWallIndexRoute
  '/$sessionId/wall/$wallNumber/$wallId': typeof SessionIdSessionStepsWallWallNumberWallIdRoute
  '/$sessionId/wall/$wallNumber/$wallId/wallDetail/$wallDetailId': typeof SessionIdSessionStepsWallWallNumberWallIdWallDetailWallDetailIdRoute
}
export interface FileRoutesByTo {
  '/permissions': typeof PermissionsRoute
  '/demo/$demoUrl': typeof DemoDemoUrlRoute
  '/$sessionId/finished': typeof SessionIdSessionFinishedRoute
  '/$sessionId/permissionsGuide': typeof SessionIdSessionPermissionsGuideRoute
  '/$sessionId/unsupportedDevice': typeof SessionIdSessionUnsupportedDeviceRoute
  '/$sessionId': typeof SessionIdSessionIndexRoute
  '/$sessionId/addNewWall': typeof SessionIdSessionStepsAddNewWallRoute
  '/$sessionId/address': typeof SessionIdSessionStepsAddressRoute
  '/$sessionId/intro/permissions': typeof SessionIdSessionIntroPermissionsRoute
  '/$sessionId/intro/wall': typeof SessionIdSessionIntroWallRoute
  '/$sessionId/intro/wallDetail': typeof SessionIdSessionIntroWallDetailRoute
  '/$sessionId/intro/welcome': typeof SessionIdSessionIntroWelcomeRoute
  '/$sessionId/intro': typeof SessionIdSessionIntroIndexRoute
  '/$sessionId/extraEquipment/$amenityType': typeof SessionIdSessionStepsExtraEquipmentAmenityTypeRoute
  '/$sessionId/utilityRoom/$amenityType': typeof SessionIdSessionStepsUtilityRoomAmenityTypeRoute
  '/$sessionId/extraEquipment': typeof SessionIdSessionStepsExtraEquipmentIndexRoute
  '/$sessionId/overview': typeof SessionIdSessionStepsOverviewIndexRoute
  '/$sessionId/utilityRoom': typeof SessionIdSessionStepsUtilityRoomIndexRoute
  '/$sessionId/wall': typeof SessionIdSessionStepsWallIndexRoute
  '/$sessionId/wall/$wallNumber/$wallId': typeof SessionIdSessionStepsWallWallNumberWallIdRoute
  '/$sessionId/wall/$wallNumber/$wallId/wallDetail/$wallDetailId': typeof SessionIdSessionStepsWallWallNumberWallIdWallDetailWallDetailIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/permissions': typeof PermissionsRoute
  '/$sessionId/_session': typeof SessionIdSessionRouteWithChildren
  '/demo/$demoUrl': typeof DemoDemoUrlRoute
  '/$sessionId/_session/finished': typeof SessionIdSessionFinishedRoute
  '/$sessionId/_session/permissionsGuide': typeof SessionIdSessionPermissionsGuideRoute
  '/$sessionId/_session/unsupportedDevice': typeof SessionIdSessionUnsupportedDeviceRoute
  '/$sessionId/_session/': typeof SessionIdSessionIndexRoute
  '/$sessionId/_session/_steps/addNewWall': typeof SessionIdSessionStepsAddNewWallRoute
  '/$sessionId/_session/_steps/address': typeof SessionIdSessionStepsAddressRoute
  '/$sessionId/_session/intro/permissions': typeof SessionIdSessionIntroPermissionsRoute
  '/$sessionId/_session/intro/wall': typeof SessionIdSessionIntroWallRoute
  '/$sessionId/_session/intro/wallDetail': typeof SessionIdSessionIntroWallDetailRoute
  '/$sessionId/_session/intro/welcome': typeof SessionIdSessionIntroWelcomeRoute
  '/$sessionId/_session/intro/': typeof SessionIdSessionIntroIndexRoute
  '/$sessionId/_session/_steps/extraEquipment/$amenityType': typeof SessionIdSessionStepsExtraEquipmentAmenityTypeRoute
  '/$sessionId/_session/_steps/utilityRoom/$amenityType': typeof SessionIdSessionStepsUtilityRoomAmenityTypeRoute
  '/$sessionId/_session/_steps/extraEquipment/': typeof SessionIdSessionStepsExtraEquipmentIndexRoute
  '/$sessionId/_session/_steps/overview/': typeof SessionIdSessionStepsOverviewIndexRoute
  '/$sessionId/_session/_steps/utilityRoom/': typeof SessionIdSessionStepsUtilityRoomIndexRoute
  '/$sessionId/_session/_steps/wall/': typeof SessionIdSessionStepsWallIndexRoute
  '/$sessionId/_session/_steps/wall/$wallNumber/$wallId': typeof SessionIdSessionStepsWallWallNumberWallIdRoute
  '/$sessionId/_session/_steps/wall/$wallNumber/$wallId_/wallDetail_/$wallDetailId': typeof SessionIdSessionStepsWallWallNumberWallIdWallDetailWallDetailIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/permissions'
    | '/$sessionId'
    | '/demo/$demoUrl'
    | '/$sessionId/finished'
    | '/$sessionId/permissionsGuide'
    | '/$sessionId/unsupportedDevice'
    | '/$sessionId/'
    | '/$sessionId/addNewWall'
    | '/$sessionId/address'
    | '/$sessionId/intro/permissions'
    | '/$sessionId/intro/wall'
    | '/$sessionId/intro/wallDetail'
    | '/$sessionId/intro/welcome'
    | '/$sessionId/intro/'
    | '/$sessionId/extraEquipment/$amenityType'
    | '/$sessionId/utilityRoom/$amenityType'
    | '/$sessionId/extraEquipment/'
    | '/$sessionId/overview/'
    | '/$sessionId/utilityRoom/'
    | '/$sessionId/wall/'
    | '/$sessionId/wall/$wallNumber/$wallId'
    | '/$sessionId/wall/$wallNumber/$wallId/wallDetail/$wallDetailId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/permissions'
    | '/demo/$demoUrl'
    | '/$sessionId/finished'
    | '/$sessionId/permissionsGuide'
    | '/$sessionId/unsupportedDevice'
    | '/$sessionId'
    | '/$sessionId/addNewWall'
    | '/$sessionId/address'
    | '/$sessionId/intro/permissions'
    | '/$sessionId/intro/wall'
    | '/$sessionId/intro/wallDetail'
    | '/$sessionId/intro/welcome'
    | '/$sessionId/intro'
    | '/$sessionId/extraEquipment/$amenityType'
    | '/$sessionId/utilityRoom/$amenityType'
    | '/$sessionId/extraEquipment'
    | '/$sessionId/overview'
    | '/$sessionId/utilityRoom'
    | '/$sessionId/wall'
    | '/$sessionId/wall/$wallNumber/$wallId'
    | '/$sessionId/wall/$wallNumber/$wallId/wallDetail/$wallDetailId'
  id:
    | '__root__'
    | '/permissions'
    | '/$sessionId/_session'
    | '/demo/$demoUrl'
    | '/$sessionId/_session/finished'
    | '/$sessionId/_session/permissionsGuide'
    | '/$sessionId/_session/unsupportedDevice'
    | '/$sessionId/_session/'
    | '/$sessionId/_session/_steps/addNewWall'
    | '/$sessionId/_session/_steps/address'
    | '/$sessionId/_session/intro/permissions'
    | '/$sessionId/_session/intro/wall'
    | '/$sessionId/_session/intro/wallDetail'
    | '/$sessionId/_session/intro/welcome'
    | '/$sessionId/_session/intro/'
    | '/$sessionId/_session/_steps/extraEquipment/$amenityType'
    | '/$sessionId/_session/_steps/utilityRoom/$amenityType'
    | '/$sessionId/_session/_steps/extraEquipment/'
    | '/$sessionId/_session/_steps/overview/'
    | '/$sessionId/_session/_steps/utilityRoom/'
    | '/$sessionId/_session/_steps/wall/'
    | '/$sessionId/_session/_steps/wall/$wallNumber/$wallId'
    | '/$sessionId/_session/_steps/wall/$wallNumber/$wallId_/wallDetail_/$wallDetailId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PermissionsRoute: typeof PermissionsRoute
  SessionIdSessionRoute: typeof SessionIdSessionRouteWithChildren
  DemoDemoUrlRoute: typeof DemoDemoUrlRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/permissions': {
      id: '/permissions'
      path: '/permissions'
      fullPath: '/permissions'
      preLoaderRoute: typeof PermissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$sessionId/_session': {
      id: '/$sessionId/_session'
      path: '/$sessionId'
      fullPath: '/$sessionId'
      preLoaderRoute: typeof SessionIdSessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/$demoUrl': {
      id: '/demo/$demoUrl'
      path: '/demo/$demoUrl'
      fullPath: '/demo/$demoUrl'
      preLoaderRoute: typeof DemoDemoUrlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$sessionId/_session/': {
      id: '/$sessionId/_session/'
      path: '/'
      fullPath: '/$sessionId/'
      preLoaderRoute: typeof SessionIdSessionIndexRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/finished': {
      id: '/$sessionId/_session/finished'
      path: '/finished'
      fullPath: '/$sessionId/finished'
      preLoaderRoute: typeof SessionIdSessionFinishedRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/permissionsGuide': {
      id: '/$sessionId/_session/permissionsGuide'
      path: '/permissionsGuide'
      fullPath: '/$sessionId/permissionsGuide'
      preLoaderRoute: typeof SessionIdSessionPermissionsGuideRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/unsupportedDevice': {
      id: '/$sessionId/_session/unsupportedDevice'
      path: '/unsupportedDevice'
      fullPath: '/$sessionId/unsupportedDevice'
      preLoaderRoute: typeof SessionIdSessionUnsupportedDeviceRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/_steps/addNewWall': {
      id: '/$sessionId/_session/_steps/addNewWall'
      path: '/addNewWall'
      fullPath: '/$sessionId/addNewWall'
      preLoaderRoute: typeof SessionIdSessionStepsAddNewWallRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/_steps/address': {
      id: '/$sessionId/_session/_steps/address'
      path: '/address'
      fullPath: '/$sessionId/address'
      preLoaderRoute: typeof SessionIdSessionStepsAddressRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/intro/': {
      id: '/$sessionId/_session/intro/'
      path: '/intro'
      fullPath: '/$sessionId/intro/'
      preLoaderRoute: typeof SessionIdSessionIntroIndexRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/intro/permissions': {
      id: '/$sessionId/_session/intro/permissions'
      path: '/intro/permissions'
      fullPath: '/$sessionId/intro/permissions'
      preLoaderRoute: typeof SessionIdSessionIntroPermissionsRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/intro/wall': {
      id: '/$sessionId/_session/intro/wall'
      path: '/intro/wall'
      fullPath: '/$sessionId/intro/wall'
      preLoaderRoute: typeof SessionIdSessionIntroWallRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/intro/wallDetail': {
      id: '/$sessionId/_session/intro/wallDetail'
      path: '/intro/wallDetail'
      fullPath: '/$sessionId/intro/wallDetail'
      preLoaderRoute: typeof SessionIdSessionIntroWallDetailRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/intro/welcome': {
      id: '/$sessionId/_session/intro/welcome'
      path: '/intro/welcome'
      fullPath: '/$sessionId/intro/welcome'
      preLoaderRoute: typeof SessionIdSessionIntroWelcomeRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/_steps/extraEquipment/': {
      id: '/$sessionId/_session/_steps/extraEquipment/'
      path: '/extraEquipment'
      fullPath: '/$sessionId/extraEquipment/'
      preLoaderRoute: typeof SessionIdSessionStepsExtraEquipmentIndexRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/_steps/extraEquipment/$amenityType': {
      id: '/$sessionId/_session/_steps/extraEquipment/$amenityType'
      path: '/extraEquipment/$amenityType'
      fullPath: '/$sessionId/extraEquipment/$amenityType'
      preLoaderRoute: typeof SessionIdSessionStepsExtraEquipmentAmenityTypeRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/_steps/overview/': {
      id: '/$sessionId/_session/_steps/overview/'
      path: '/overview'
      fullPath: '/$sessionId/overview/'
      preLoaderRoute: typeof SessionIdSessionStepsOverviewIndexRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/_steps/utilityRoom/': {
      id: '/$sessionId/_session/_steps/utilityRoom/'
      path: '/utilityRoom'
      fullPath: '/$sessionId/utilityRoom/'
      preLoaderRoute: typeof SessionIdSessionStepsUtilityRoomIndexRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/_steps/utilityRoom/$amenityType': {
      id: '/$sessionId/_session/_steps/utilityRoom/$amenityType'
      path: '/utilityRoom/$amenityType'
      fullPath: '/$sessionId/utilityRoom/$amenityType'
      preLoaderRoute: typeof SessionIdSessionStepsUtilityRoomAmenityTypeRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/_steps/wall/': {
      id: '/$sessionId/_session/_steps/wall/'
      path: '/wall'
      fullPath: '/$sessionId/wall/'
      preLoaderRoute: typeof SessionIdSessionStepsWallIndexRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/_steps/wall/$wallNumber/$wallId': {
      id: '/$sessionId/_session/_steps/wall/$wallNumber/$wallId'
      path: '/wall/$wallNumber/$wallId'
      fullPath: '/$sessionId/wall/$wallNumber/$wallId'
      preLoaderRoute: typeof SessionIdSessionStepsWallWallNumberWallIdRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/_steps/wall/$wallNumber/$wallId_/wallDetail_/$wallDetailId': {
      id: '/$sessionId/_session/_steps/wall/$wallNumber/$wallId_/wallDetail_/$wallDetailId'
      path: '/wall/$wallNumber/$wallId/wallDetail/$wallDetailId'
      fullPath: '/$sessionId/wall/$wallNumber/$wallId/wallDetail/$wallDetailId'
      preLoaderRoute: typeof SessionIdSessionStepsWallWallNumberWallIdWallDetailWallDetailIdRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
  }
}

interface SessionIdSessionRouteChildren {
  SessionIdSessionFinishedRoute: typeof SessionIdSessionFinishedRoute
  SessionIdSessionPermissionsGuideRoute: typeof SessionIdSessionPermissionsGuideRoute
  SessionIdSessionUnsupportedDeviceRoute: typeof SessionIdSessionUnsupportedDeviceRoute
  SessionIdSessionIndexRoute: typeof SessionIdSessionIndexRoute
  SessionIdSessionStepsAddNewWallRoute: typeof SessionIdSessionStepsAddNewWallRoute
  SessionIdSessionStepsAddressRoute: typeof SessionIdSessionStepsAddressRoute
  SessionIdSessionIntroPermissionsRoute: typeof SessionIdSessionIntroPermissionsRoute
  SessionIdSessionIntroWallRoute: typeof SessionIdSessionIntroWallRoute
  SessionIdSessionIntroWallDetailRoute: typeof SessionIdSessionIntroWallDetailRoute
  SessionIdSessionIntroWelcomeRoute: typeof SessionIdSessionIntroWelcomeRoute
  SessionIdSessionIntroIndexRoute: typeof SessionIdSessionIntroIndexRoute
  SessionIdSessionStepsExtraEquipmentAmenityTypeRoute: typeof SessionIdSessionStepsExtraEquipmentAmenityTypeRoute
  SessionIdSessionStepsUtilityRoomAmenityTypeRoute: typeof SessionIdSessionStepsUtilityRoomAmenityTypeRoute
  SessionIdSessionStepsExtraEquipmentIndexRoute: typeof SessionIdSessionStepsExtraEquipmentIndexRoute
  SessionIdSessionStepsOverviewIndexRoute: typeof SessionIdSessionStepsOverviewIndexRoute
  SessionIdSessionStepsUtilityRoomIndexRoute: typeof SessionIdSessionStepsUtilityRoomIndexRoute
  SessionIdSessionStepsWallIndexRoute: typeof SessionIdSessionStepsWallIndexRoute
  SessionIdSessionStepsWallWallNumberWallIdRoute: typeof SessionIdSessionStepsWallWallNumberWallIdRoute
  SessionIdSessionStepsWallWallNumberWallIdWallDetailWallDetailIdRoute: typeof SessionIdSessionStepsWallWallNumberWallIdWallDetailWallDetailIdRoute
}

const SessionIdSessionRouteChildren: SessionIdSessionRouteChildren = {
  SessionIdSessionFinishedRoute: SessionIdSessionFinishedRoute,
  SessionIdSessionPermissionsGuideRoute: SessionIdSessionPermissionsGuideRoute,
  SessionIdSessionUnsupportedDeviceRoute:
    SessionIdSessionUnsupportedDeviceRoute,
  SessionIdSessionIndexRoute: SessionIdSessionIndexRoute,
  SessionIdSessionStepsAddNewWallRoute: SessionIdSessionStepsAddNewWallRoute,
  SessionIdSessionStepsAddressRoute: SessionIdSessionStepsAddressRoute,
  SessionIdSessionIntroPermissionsRoute: SessionIdSessionIntroPermissionsRoute,
  SessionIdSessionIntroWallRoute: SessionIdSessionIntroWallRoute,
  SessionIdSessionIntroWallDetailRoute: SessionIdSessionIntroWallDetailRoute,
  SessionIdSessionIntroWelcomeRoute: SessionIdSessionIntroWelcomeRoute,
  SessionIdSessionIntroIndexRoute: SessionIdSessionIntroIndexRoute,
  SessionIdSessionStepsExtraEquipmentAmenityTypeRoute:
    SessionIdSessionStepsExtraEquipmentAmenityTypeRoute,
  SessionIdSessionStepsUtilityRoomAmenityTypeRoute:
    SessionIdSessionStepsUtilityRoomAmenityTypeRoute,
  SessionIdSessionStepsExtraEquipmentIndexRoute:
    SessionIdSessionStepsExtraEquipmentIndexRoute,
  SessionIdSessionStepsOverviewIndexRoute:
    SessionIdSessionStepsOverviewIndexRoute,
  SessionIdSessionStepsUtilityRoomIndexRoute:
    SessionIdSessionStepsUtilityRoomIndexRoute,
  SessionIdSessionStepsWallIndexRoute: SessionIdSessionStepsWallIndexRoute,
  SessionIdSessionStepsWallWallNumberWallIdRoute:
    SessionIdSessionStepsWallWallNumberWallIdRoute,
  SessionIdSessionStepsWallWallNumberWallIdWallDetailWallDetailIdRoute:
    SessionIdSessionStepsWallWallNumberWallIdWallDetailWallDetailIdRoute,
}

const SessionIdSessionRouteWithChildren =
  SessionIdSessionRoute._addFileChildren(SessionIdSessionRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PermissionsRoute: PermissionsRoute,
  SessionIdSessionRoute: SessionIdSessionRouteWithChildren,
  DemoDemoUrlRoute: DemoDemoUrlRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
